import { CircleDot, FilePlus2, Link2, Link2Off, Pencil } from 'lucide-react';
import type { EventoIncidente } from '@/data/types';
import { formatarDataHora, formatarRelativo } from '@/lib/format';
import { descreverEventoIncidente } from './evento-incidente';

const ICONE: Record<EventoIncidente['tipo'], typeof Pencil> = {
  criado: FilePlus2,
  editado: Pencil,
  status: CircleDot,
  versao_adicionada: Link2,
  versao_removida: Link2Off,
};

/** Linha do tempo de auditoria do incidente, mais recente primeiro. */
export function LinhaDoTempoIncidente({ eventos }: { eventos: EventoIncidente[] }) {
  if (eventos.length === 0) {
    return <p className="text-body text-on-surface-muted">Nenhum evento registrado para este incidente.</p>;
  }
  return (
    <ol className="flex flex-col" aria-label="Linha do tempo do incidente">
      {eventos.map((evento, indice) => {
        const Icone = ICONE[evento.tipo] ?? Pencil;
        const descrito = descreverEventoIncidente(evento);
        return (
          <li key={evento.id} className="relative flex gap-3 pb-5 last:pb-0">
            {indice < eventos.length - 1 ? (
              <span className="absolute left-[15px] top-8 h-[calc(100%-2rem)] w-px bg-border" aria-hidden="true" />
            ) : null}
            <span className="flex size-8 shrink-0 items-center justify-center rounded-full border border-border bg-bg-subtle text-icon [&_svg]:size-4">
              <Icone aria-hidden="true" />
            </span>
            <div className="flex min-w-0 flex-col gap-0.5 pt-1">
              <p className="text-body font-bold">{descrito.resumo}</p>
              {descrito.mudancas.length > 0 ? (
                <ul className="flex flex-col gap-0.5 text-cell">
                  {descrito.mudancas.map((mudanca) => (
                    <li key={mudanca.campo} className="break-words">
                      <span className="font-bold">{mudanca.campo}:</span>{' '}
                      <span className="text-on-surface-muted line-through decoration-1">{mudanca.de}</span>
                      <span aria-label=" para " className="mx-1.5 text-icon">
                        →
                      </span>
                      <span>{mudanca.para}</span>
                    </li>
                  ))}
                </ul>
              ) : null}
              {descrito.complemento ? (
                <p className="break-words font-mono text-cell text-on-surface-muted">{descrito.complemento}</p>
              ) : null}
              <p className="text-cell text-on-surface-muted">
                {evento.usuario} ·{' '}
                <time dateTime={evento.criado_em} title={formatarDataHora(evento.criado_em)}>
                  {formatarRelativo(evento.criado_em)}
                </time>
              </p>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
